export default "__VITE_PUBLIC_ASSET__74840c8a__"